import React from 'react';
import {Textarea} from "@material-tailwind/react";
import {CustomTypography} from "./CustomTypography";
import {useTranslation} from "react-i18next";

interface CustomTextAreaProps {
    label: string;
    labelFixel?: boolean;
    className?: string;
    placeholder?: string;
    value?: string;
    error?: string;
    disabled?: boolean;
    mandatory?: boolean;
    onChangeText?: (text: string) => void;
}

function CustomTextArea({ label, labelFixel, className, placeholder, disabled, mandatory, error, ...props }: CustomTextAreaProps) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const handleInputChange = (event: any) => {
        const value = event.target.value;
        return  value.replace(/[#&/*{}\[\]@_\-><`^"~+°|]/g, '');
    };

    return (
        <div className='w-full grid grid-cols-1 mb-1'>
            {(props?.value !== '' || labelFixel) &&
                <label className={`${disabled ? 'text-colorDisabled' : 'text-labelColor'} normal-case text-[10px] absolute bg-white 
                mt-[-7px] ml-[18px] labelCustom px-1 rounded-[5px]`}>{t(label ?? '')}{mandatory &&
                    <span className={'text-danger ml-[2px]'}>*</span>}</label>
            }
            <Textarea
                disabled={disabled}
                className={`styleInput custom-text-area 
                ${error ? '!border-danger placeholder:text-danger' : disabled ? '!border-colorDisabled' : '!border-inputBorder'} 
                ${disabled ? 'cursor-text' : ''} ${className ? className : ''} 
                text-input pt-2 min-h-[40px] !border !border-inputBorder bg-white text-gray-900 shadow-lg 
                shadow-gray-900/5 ring-1 ring-transparent placeholder:text-gray-500 focus:!border-primary 
                focus:!border-t-primary focus:ring-white disabled:bg-white`}
                labelProps={{
                    className: "hidden",
                }}
                containerProps={{ className: "min-w-[100px]" }}
                label={label}
                placeholder={placeholder}
                value={props.value}
                error={error !== undefined}
                onChange={(e) => {
                    if (props.onChangeText) props.onChangeText(handleInputChange(e))
                }}></Textarea>
            {error && <CustomTypography variant="small" style={{color: 'red'}} className="font-normal ml-2" text={error}/>}
        </div>
    );
}

export default CustomTextArea;
